import { FieldModel } from '../extraction-models';
import { DataAwareValidator } from '../../domain-extraction-specifications';
import { CtBatchSource } from '@ps-gui/claims-terminal-shared';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

export const ConsolidationSectionEingangstyp = {
  mandant: {
    key: 'tenant',
    label: { text: 'Mandant', genus: 'M' },
    type: FieldType.DROPDOWN,
    options: [],
    index: 0,
    validators: [Validations.required()],
  },
  auftragsart: {
    key: 'auftragsart',
    label: { text: 'Auftragsart', genus: 'F' },
    type: FieldType.DROPDOWN,
    options: [],
    index: 1,
    validators: [Validations.required()],
  },
  eingangstyp: {
    key: 'eingangstyp',
    label: { text: 'Eingangstyp', genus: 'M' },
    type: FieldType.RADIO,
    options: ['Neuer Auftrag', 'Nachreichung', 'Widerspruch'],
    defaultValue: 'Neuer Auftrag',
    index: 2,
    validators: [],
    visibleForSource: [CtBatchSource.NEW_BACKEND],
  },
} satisfies Record<
  string,
  FieldModel & {
    dataAwareValidator?: DataAwareValidator;
  }
>;
